export const AssistantEnums = {
  routes: {
    INITIATE_THREAD: `${process.env.REACT_APP_NODE_RED_URL}/api/assistants/friendly-assistant/query`,
    RUN_THREAD: '',
    CONTINUE_THREAD: `${process.env.REACT_APP_NODE_RED_URL}/api/assistants/friendly-assistant/continue`,
    READ_THREAD: `${process.env.REACT_APP_NODE_RED_URL}/api/assistants/friendly-assistant/response`,
    CHECK_THREAD_STATUS: `${process.env.REACT_APP_NODE_RED_URL}/api/assistants/friendly-assistant/run-status`
  },
  assistant_ids: {
    MEDICAL_CHATBOT: 'asst_iCczNvKn9aIgZVFSOJ247ZZ0',
    REFERRAL_LETTER: 'asst_QzDnRXMu0Sqo6GYOvuYbYET6',
    CLINICAL_NOTES: 'asst_iCnR3oq5XQshJMkiLeUBtPtC',
    DATA_EXTRACTION_AI: 'asst_qH1qSVxMnVFGgaNoSSC9R4CP',
    MACRO_TRACKER: 'asst_LtZK0rHmyugNgRB82H6oBiW6',
    PROTOCOLS: 'asst_DvR4JnQUS7Vao8GXzkyLAcEq',
    PROTOCOLS_ALT: 'asst_Nx7e443mKtmJWW3vvBsIQgHH',
    CONSULT_SUMMARY: 'asst_Vg1EvoAbZbh6IMKyeoZVQyov',
    MEDICAL_CHATBOT_ALT: 'asst_vb4ONL43qHqwZuTlLd1XGNzZ',
    MEDICAL_CHATBOT_ALT_2: 'asst_Vg1EvoAbZbh6IMKyeoZVQyov'
  },
  api_key:
    process.env.REACT_APP_OPENAI_API_KEY ||
    (process.env.NODE_ENV === 'production'
      ? ''
      : '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')
}
